import { render, staticRenderFns } from "./add-column-name.vue?vue&type=template&id=c8a8f142&"
import script from "./add-column-name.vue?vue&type=script&lang=js&"
export * from "./add-column-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports